import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { DisplayTemplateSource } from '@/client/types';

const displayTemplateSourceStorage = createJSONStorage<DisplayTemplateSource | null>(
  () => globalThis.sessionStorage
);

/** Session override for X-Display-Template-Source; null follows LD ux-config. */
export const displayTemplateSourceOverrideAtom = atomWithStorage<DisplayTemplateSource | null>(
  'devtools-display-template-source',
  null,
  displayTemplateSourceStorage
);
displayTemplateSourceOverrideAtom.debugLabel = 'displayTemplateSourceOverride';
